import { render, staticRenderFns } from "./ViewDetail.vue?vue&type=template&id=1065ff5d&"
import script from "./ViewDetail.vue?vue&type=script&lang=js&"
export * from "./ViewDetail.vue?vue&type=script&lang=js&"
import style0 from "./ViewDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ViewDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports